/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import { sentenceCase, capitalCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
  Tabs,
  Button,
  Tab,
  useMediaQuery,
  Grid,
  Divider,
  Collapse,
  Box,
  Stack,
  Chip,
  IconButton,
  Tooltip,
} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Iconify from '../../components/Iconify';
import EmptyContent from '../../components/EmptyContent';

// format
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';

import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// format number
import { fCurrency } from '../../utils/formatNumber';
// sections
import { TransHead, PlanToolbar } from '../../sections/admin/user/list';

// axios

import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'transid', label: 'System ID', alignRight: false },
  { id: 'account_name', label: 'Account Name', alignRight: false },
  { id: 'account_number', label: 'Account Number', alignRight: false },
  { id: 'bank_name', label: 'Bank Name', alignRight: false },
  { id: 'bank_code', label: 'Bank Code', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'plan_status', label: 'Plan Status', alignRight: false },
  { id: 'invioce', label: 'INVIOCE', alignRight: false },
];
const ACCOUNT_TABS = [
  {
    value: 'ALL',
    label: 'ALL',
  },
  {
    value: 1,
    label: 'success',
  },
  {
    value: 0,
    label: 'processing',
  },
  {
    value: 2,
    label: 'fail',
  },
];
// ----------------------------------------------------------------------

export default function ManualTransfer() {
  const theme = useTheme();
  const { themeStretch } = useSettings();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [load, SetLoad] = useState(true);
  const [totalPage, SetTotal] = useState(0);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, Setdense] = useState(false);
  const [isNotFound, SetNotFound] = useState(false);
  const [status, setStatus] = useState('ALL');
  const AccessToken = window.localStorage.getItem('accessToken');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    initialize(page, rowsPerPage, status, filterName);
  }, []);

  const initialize = async (pag, adex = 5, status, search) => {
    let adex_page;
    if (pag > page) {
      adex_page = pag + 1;
    } else {
      adex_page = pag;
    }
    try {
      SetLoad(true);
      const data = await axios.get(
        `/api/system/all/trans/${AccessToken}/secure?page=${adex_page}&adex=${adex}&status=${status}&search=${search}&database_name=bank_trans`
      );
      setUserList(data.data?.bank_trans?.data);
      SetLoad(false);
      SetTotal(data.data?.bank_trans?.total);
      SetLoad(false);
      setPage(pag);
      SetNotFound(data.data?.bank_trans?.total === 0);
    } catch (_) {
      SetLoad(false);
      setUserList([]);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    initialize(0, event.target.value, status, filterName);
    setPage(0);
  };

  const handleFilterByName = async (filterName) => {
    setFilterName(filterName);
    setPage(0);
    if (filterName) {
      initialize(page, rowsPerPage, status, filterName);
    } else {
      initialize(page, rowsPerPage, status, filterName);
      SetNotFound(false);
      SetLoad(false);
    }
  };

  function handleChangeDense(event) {
    Setdense(event.target.checked);
  }

  const handleRowToggle = (transid) => {
    setExpandedRows((prev) => ({
      ...prev,
      [transid]: !prev[transid],
    }));
  };

  // Mobile Accordion Row Component
  const MobileAccordionRow = ({ row, expanded, onToggle }) => {
    const { account_name, account_number, bank_name, bank_code, amount, date, plan_status, transid } = row;
    let statusProps = { label: '', color: 'default', icon: null };
    if (plan_status === 1) {
      statusProps = {
        label: 'Successful',
        color: 'success',
        icon: <Iconify icon="eva:checkmark-circle-2-fill" width={18} height={18} />,
      };
    } else if (plan_status === 0) {
      statusProps = {
        label: 'Processing',
        color: 'warning',
        icon: <Iconify icon="eva:clock-outline" width={18} height={18} />,
      };
    } else if (plan_status === 2) {
      statusProps = {
        label: 'Failed',
        color: 'error',
        icon: <Iconify icon="eva:close-circle-fill" width={18} height={18} />,
      };
    }
    return (
      <Card
        sx={{
          mb: 1,
          borderRadius: 2,
          boxShadow: 1,
          border: expanded ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
          transition: 'all 0.3s ease',
        }}
      >
        <Box
          sx={{ p: 2, cursor: 'pointer', '&:hover': { backgroundColor: theme.palette.action.hover } }}
          onClick={onToggle}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                {account_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {bank_name}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                label={statusProps.label}
                color={statusProps.color}
                icon={statusProps.icon}
                size="small"
                sx={{ fontWeight: 600 }}
              />
              <IconButton size="small">
                <Iconify icon={expanded ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} width={20} height={20} />
              </IconButton>
            </Box>
          </Stack>
        </Box>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box sx={{ px: 2, pb: 2 }}>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  System ID
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {transid}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Account Number
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {account_number}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Bank Code
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {bank_code}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Amount
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  ₦{fCurrency(amount)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Date
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {date}
                </Typography>
              </Grid>
            </Grid>
            <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
              <Tooltip title="Generate Invoice">
                <IconButton
                  color="primary"
                  component={RouterLink}
                  to={`${PATH_DASHBOARD.general.invioce}/${transid}/manual`}
                  sx={{
                    borderRadius: 2,
                    border: `1px solid ${theme.palette.primary.main}`,
                    '&:hover': { backgroundColor: theme.palette.primary.main, color: 'white' },
                  }}
                >
                  <Iconify icon="eva:file-text-outline" width={22} height={22} />
                </IconButton>
              </Tooltip>
            </Stack>
          </Box>
        </Collapse>
      </Card>
    );
  };

  const handleAccordionToggle = (transid) => () => handleRowToggle(transid);

  const renderMobileView = () => {
    if (load) {
      return (
        <Box sx={{ mt: 2 }}>
          {[...Array(rowsPerPage)].map((_, idx) => (
            <Card key={idx} sx={{ mb: 1, p: 2, borderRadius: 2 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ width: 100, height: 16, bgcolor: 'grey.200', borderRadius: 1, mb: 1 }} />
                  <Box sx={{ width: 80, height: 12, bgcolor: 'grey.200', borderRadius: 1 }} />
                </Box>
                <Box sx={{ width: 80, height: 24, bgcolor: 'grey.200', borderRadius: 1 }} />
              </Stack>
            </Card>
          ))}
        </Box>
      );
    }
    if (userList.length > 0) {
      return (
        <Box sx={{ mt: 2 }}>
          {userList.map((row) => (
            <MobileAccordionRow
              key={row.transid}
              row={row}
              expanded={expandedRows[row.transid] || false}
              onToggle={handleAccordionToggle(row.transid)}
            />
          ))}
        </Box>
      );
    }
    return (
      <Box sx={{ mt: 2 }}>
        <Card sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
          <EmptyContent
            title="No Manual Funding Transactions"
            description="No manual funding transactions found for your current filter."
            img="/upload/notfound.png"
          />
        </Card>
      </Box>
    );
  };

  const renderDesktopView = () => (
    <Scrollbar>
      <TableContainer sx={{ minWidth: 900, borderRadius: 2, boxShadow: 0 }}>
        <Table size={dense ? 'small' : 'medium'}>
          <TransHead order={'asc'} orderBy={'id'} headLabel={TABLE_HEAD} rowCount={userList.length} />
          {load ? (
            <TableBody>
              {[...Array(rowsPerPage)].map((_, idx) => (
                <TableRow key={idx}>
                  {TABLE_HEAD.map((col) => (
                    <TableCell key={col.id}>
                      <Box sx={{ width: 80, height: 16, bgcolor: 'grey.200', borderRadius: 1 }} />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              {userList.length > 0 ? (
                userList.map((row) => {
                  const { account_name, account_number, bank_name, bank_code, amount, date, plan_status, transid } =
                    row;
                  let statusProps = { label: '', color: 'default', icon: null };
                  if (plan_status === 1) {
                    statusProps = {
                      label: 'Successful',
                      color: 'success',
                      icon: <Iconify icon="eva:checkmark-circle-2-fill" width={18} height={18} />,
                    };
                  } else if (plan_status === 0) {
                    statusProps = {
                      label: 'Processing',
                      color: 'warning',
                      icon: <Iconify icon="eva:clock-outline" width={18} height={18} />,
                    };
                  } else if (plan_status === 2) {
                    statusProps = {
                      label: 'Failed',
                      color: 'error',
                      icon: <Iconify icon="eva:close-circle-fill" width={18} height={18} />,
                    };
                  }
                  return (
                    <TableRow hover key={transid} tabIndex={-1} role="checkbox">
                      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="subtitle2" noWrap>
                          {transid}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">{account_name}</TableCell>
                      <TableCell align="left">{account_number}</TableCell>
                      <TableCell align="left">{bank_name}</TableCell>
                      <TableCell align="left">{bank_code}</TableCell>
                      <TableCell align="left">₦{fCurrency(amount)}</TableCell>
                      <TableCell align="left">{date}</TableCell>
                      <TableCell align="left">
                        <Chip
                          label={statusProps.label}
                          color={statusProps.color}
                          icon={statusProps.icon}
                          size="small"
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell align="left">
                        <Tooltip title="Generate Invoice">
                          <IconButton
                            color="primary"
                            component={RouterLink}
                            to={`${PATH_DASHBOARD.general.invioce}/${transid}/manual`}
                          >
                            <Iconify icon="eva:file-text-outline" width={22} height={22} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={TABLE_HEAD.length} align="center" sx={{ py: 5 }}>
                    <EmptyContent
                      title="No Manual Funding Transactions"
                      description="No manual funding transactions found for your current filter."
                      img="/upload/notfound.png"
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Scrollbar>
  );

  // Helper functions for tab color and background
  const getTabColor = (theme, status, tabValue) => {
    const isLight = theme.palette.mode === 'light';
    const isActive = status === tabValue;
    if (isActive) {
      return theme.palette.primary.contrastText;
    }
    return theme.palette.text.secondary;
  };
  const getTabBackground = (theme, status, tabValue) => {
    const isLight = theme.palette.mode === 'light';
    const isActive = status === tabValue;
    if (isActive) {
      return theme.palette.primary.main;
    }
    return 'transparent';
  };

  const handleTabChange = (e, value) => {
    setStatus(value);
    initialize(page, rowsPerPage, value, filterName);
  };

  return (
    <Page title="Transaction:  Manual Funding">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Manual Funding"
          links={[{ name: 'Dashboard', href: PATH_DASHBOARD.general.app }, { name: 'List' }]}
        />

        <Card>
          <Box sx={{ mb: 3, mt: 3, display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                display: 'inline-flex',
                borderRadius: 999,
                px: 1,
                py: 0.5,
                background: (theme) =>
                  theme.palette.mode === 'light' ? theme.palette.background.neutral : theme.palette.grey[900],
                minHeight: 48,
                maxWidth: '100%',
                boxShadow: 'none',
                border: 'none',
              }}
            >
              <Tabs
                value={status}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ sx: { display: 'none' } }}
                sx={{
                  minHeight: 40,
                  '& .MuiTab-root': {
                    minWidth: 100,
                    px: 2,
                  },
                }}
              >
                {ACCOUNT_TABS.map((tab) => (
                  <Tab
                    disableRipple
                    key={tab.value}
                    label={capitalCase(tab.label)}
                    value={tab.value}
                    sx={{
                      minWidth: 70,
                      px: 1.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 600,
                      fontSize: 16,
                      color:
                        status === tab.value
                          ? theme.palette.primary.contrastText
                          : getTabColor(theme, status, tab.value),
                      background:
                        status === tab.value ? theme.palette.primary.main : getTabBackground(theme, status, tab.value),
                      boxShadow: 'none',
                      border: 'none',
                      zIndex: status === tab.value ? 1 : 0,
                      transition: 'all 0.2s',
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </Box>
          <PlanToolbar filterName={filterName} onFilterName={handleFilterByName} />

          {isMobile ? renderMobileView() : renderDesktopView()}

          <FormControlLabel
            control={<Switch checked={dense} onChange={(event) => handleChangeDense(event)} />}
            label="Dense padding"
            align="left"
          />

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={totalPage}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, page) => initialize(page, rowsPerPage, status, filterName)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}

// ----------------------------------------------------------------------
